export default __webpack_public_path__ + "static/media/12.b2c68fac.PNG";